import { ActiveErrorStatus, FaultCode } from '@vi-iot/client';
import { DeviceTypes, StatusContent } from '../gateway';

export interface ActiveErrorDetailsState {
  faultCodes: FaultCode[];
  countryCode?: string;
  languageCode?: string;
  loading: boolean;
  loaded: boolean;
  searchParams?: any;
  error: any;
}

export interface ActiveErrorsQueryParams {
  deviceId?: string;
  equipmentType?: string;
  errorCode?: string;
  errorEventType?: string;
  gatewaySerial?: string;
  isActive?: boolean;
  limit?: number;
  offset?: number;
}

export interface ActiveErrorData {
  errorCode: string;
  appearedAt: string;
  createdAt: string;
  editedAt?: string;
  errorDescription: string;
  deviceId: string;
  gatewaySerial: string;
  id: number;
  details: FaultCode;
  deviceSerial: string;
  countryCode: string;
  langCode: string;
  type: string;
  loading: boolean;
  loaded: boolean;
  isSelected: boolean;
  deviceType?: DeviceTypes;
  content?: StatusContent;
  status?: ActiveErrorStatus;
}

export interface DisplayedErrorState {
  countOfAllErrors: number;
  displayedErrors: ActiveErrorData[];
  maintenanceNotifications?: ActiveErrorData[];
  powerLimitationStatuses?: ActiveErrorData[];
}

export enum ACTIVE_ERROR_TYPE {
  SYSTEM_LOCKED = 'system-locked',
  DEVICE_ERROR = 'device-error',
  BATTERY_LOW = 'device-battery-level-low',
  FILTER_EXCHANGE = 'filter-exchange',
  FILTER_EXCHANGE_14_DAYS = 'filter-exchange-needed-14-days',
  SALT_CARTRIDGE_EXCHANGE = 'salt-cartridge-exchange',
  MAINTENANCE_TIMEBASED = 'maintenance-timebased-v2-vgw',
  MAINTENANCE_BURNERBASED = 'maintenance-burnerbased',
  MAINTENANCE_NEEDED_IN_45_D = 'maintenance-needed-in-45-days',
  MAINTENANCE_NEEDED_IN_30_D = 'maintenance-needed-in-30-days',
  MAINTENANCE_NEEDED = 'maintenance-needed',
  DEVICE_BATTERY_LEVEL_LOW = 'device-battery-level-low',
  MAINTENANCE = 'maintenance',
  FILTER_CHANGE_MODE_ACTIVATED = 'filter-change-mode-activated',
  FLOOR_HEATING_OVERHEATING = 'floor-heating-overheating',
  POWER_LIMITATION_CONSUMPTION = 'limitation-power-consumption',
  POWER_LIMITATION_POWER_PRODUCTION = 'limitation-power-production',
  SRC_DEVICE_OFFLINE = 'src-device-offline',
  COMFORT_ENSURING_MODE_CHANGED = 'comfort-ensuring-mode-changed',
}

export enum ACTIVE_ERROR_DESCRIPTION {
  FILTER_EXCHANGE_14_DAYS = 'filter-exchange-needed-14-days-description',
  ROOM_NAME = 'room-name',
  ID = 'device-id',
  DESCRIPTION = 'description',
}
export enum ACTIVE_ERROR_CASCADES {
  TCU = 'TCU',
  ENERGY_MANAGEMENT = 'HEMS',
  EEBUS = 'EEBUS',
  UNKNOWN = 'UNKNOWN',
  HEATING_DEVICES = 'HEATING',
  VIRTUAL = 'VIRTUAL',
  LOW_POWER_FUNK = 'ZIGBEE',
  VENTILATION_DEVICE = 'VENTILATION',
  ROOM_CONTROL = 'ROOMCONTROL',
  VITOCONNECT = 'VITOCONNECT',
  PHOTOVOLTAIC = '3RDPARTYPV',
  ELECTRICITY_STORAGE_DEVICE = 'ELECTRICITYSTORAGE',
  CHARGING_STATION = 'VEHICLECHARGINGSTATION',
}

export const localStorageIgnoredSmartNotes = 'localStorageIgnoredSmartNotes';
